import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { differenceInYears, parseISO } from 'date-fns';

import { Wrapper, ReviewerInfo, Name, Details } from './styles';
import StarRating from '@spa/shared/components/Reviews/StarRating';
import ReadMoreInline from '@spa/shared/components/ReadMoreInline';
import { COUNTRY_CODES } from '@spa/shared/constants/countryCodes';
import { formatDate, decade } from '@spa/shared/utils/date';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
import { PURPOSE_OF_STAY } from '@spa/shared/constants/purposeOfStay';

const Comment = ({ item }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const { label } =
    PURPOSE_OF_STAY.find(({ value }) => item.guest.about_stay.purpose_of_stay === value) ?? PURPOSE_OF_STAY.OTHER;
  const nationality = item?.guest_profile?.advanced_info?.nationality?.toUpperCase();
  const moveOut = parseISO(item.guest.move_in_out.end);
  const decadeYears = decade(differenceInYears(moveOut, parseISO(item?.guest_profile?.advanced_info?.birth_date)));
  const { emoji = '' } = COUNTRY_CODES.find(({ code }) => code === nationality);

  const moved = `${t('Moved out in')} ${formatDate(moveOut, language, 'MMMM yyyy')}`;
  const ageDescription = t('{{decade}} to {{endDecade}} years', { decade: decadeYears, endDecade: decadeYears + 9 });
  const purpose = `${t(capitalizeFirstLetter(label))}`;
  const details = `${moved} · ${ageDescription} · ${purpose}`;

  return (
    <Wrapper>
      <ReviewerInfo>
        <Name>
          {item.guest.full_name.first}
          <span>{emoji}</span>
        </Name>
        <Details>{details}</Details>
        <StarRating rating={item.review.property_review.content.grades_average} withGrade={false} />
      </ReviewerInfo>
      <ReadMoreInline text={item.review.property_review.content.message} maxLines={3} />
    </Wrapper>
  );
};

Comment.propTypes = {
  item: PropTypes.object.isRequired
};

export default Comment;
